import supabase from '../supabase/supabase';

const PAGE_SIZE = 50;

export const auditService = {
  async listLogs({ search = '', module = 'All', action = 'All', page = 0 } = {}) {
    let query = supabase
      .from('audit_logs_1787900000000')
      .select('*')
      .order('created_at', { ascending: false })
      .range(page * PAGE_SIZE, page * PAGE_SIZE + PAGE_SIZE - 1);

    if (module !== 'All') {
      query = query.eq('module', module);
    }

    if (action !== 'All') {
      query = query.eq('action', action);
    }

    if (search.trim()) {
      const term = search.trim();
      query = query.or(
        `actor_email.ilike.%${term}%,description.ilike.%${term}%,table_name.ilike.%${term}%`
      );
    }

    const { data, error } = await query;
    if (error) throw error;

    const logs = data || [];
    const actorIds = [...new Set(logs.map(log => log.actor_id).filter(Boolean))];

    if (!actorIds.length) {
      return logs;
    }

    const { data: profiles } = await supabase
      .from('profiles_20240320')
      .select('id, first_name, last_name, email')
      .in('id', actorIds);

    const profileMap = new Map(
      (profiles || []).map(profile => [
        profile.id,
        {
          firstName: profile.first_name,
          lastName: profile.last_name,
          email: profile.email
        }
      ])
    );

    return logs.map(log => ({
      ...log,
      actor_name: profileMap.get(log.actor_id)
        ? `${profileMap.get(log.actor_id).firstName || ''} ${profileMap.get(log.actor_id).lastName || ''}`.trim()
        : ''
    }));
  },

  async recordEvent({
    accountId,
    action = 'SYSTEM',
    module = 'Administration',
    tableName = '',
    recordId = null,
    description = '',
    metadata = {}
  }) {
    if (!accountId) return null;

    const { data, error } = await supabase.rpc('write_audit_log', {
      p_account_id: accountId,
      p_action: action,
      p_module: module,
      p_table_name: tableName,
      p_record_id: recordId,
      p_description: description,
      p_old_data: null,
      p_new_data: null,
      p_metadata: metadata
    });

    if (error) {
      console.warn('Audit event was not recorded:', error.message);
      return null;
    }

    return data;
  }
};